import type { ApiServiceInterface, SentryService } from '@travelata-libs/utils';
import type { Store } from 'vuex';
import { createToken } from './createToken';
import type { AppConfig, DestinationTracker } from './types';

export const STORE_TOKEN = createToken<Store<unknown>>('travelata-frontend/store');
export const APP_CONFIG_TOKEN = createToken<AppConfig>('travelata-frontend/appConfig');
export const API_SERVICE_TOKEN = createToken<ApiServiceInterface>('travelata-frontend/apiService');
export const SENTRY_SERVICE_TOKEN = createToken<SentryService>('travelata-frontend/logger');
export const TRACKER_TOKEN = createToken<DestinationTracker>('travelata-frontend/tracker');
